import { Button, Empty } from 'antd';
import { FileImageOutlined, FileSearchOutlined, InboxOutlined } from '../icons';

const ICONS = {
  inbox: <InboxOutlined />,
  search: <FileSearchOutlined />,
  image: <FileImageOutlined />,
} as const;

export function EmptyState(props: {
  text: string;
  kind?: keyof typeof ICONS;
  /** 可选的下一步操作，例如「重新加载」。加载失败时不能只报错不给出口。 */
  action?: { label: string; onClick: () => void };
}) {
  return (
    <Empty image={ICONS[props.kind ?? 'inbox']} description={props.text}>
      {props.action ? (
        <Button className="touch" onClick={props.action.onClick}>
          {props.action.label}
        </Button>
      ) : null}
    </Empty>
  );
}
